<template>
  <v-autocomplete
    v-model="devotional"
    :items="devotionals"
    :disabled="isDisabled"
    label="Devotional"
    @input="onInput"
  />
</template>

<script>
export default {
  name: 'DevotionalSelect',
  data: () => ({
    devotional: null,
    devotionals: [],

    isDisabled: false
  }),
  props: {
    value: Number,
    set: {
      type: Number,
      default: null
    }
  },
  watch: {
    value: function () {
      this.devotional = this.value
    },
    set: function (newVal, oldVal) {
      // When our set changes, make sure we clear any currently selected devotional
      // and then fetch new ones to pick from (but don't clear it if this is our
      // first time changing the set value, which would destroy the initial prop
      // value set for the devotional)
      if (oldVal !== null) {
        this.devotional = null
        this.onInput()
      }
      this.fetchDevotionals()
    }
  },
  mounted: function () {
    this.fetchDevotionals()
  },
  methods: {
    // Propagate our selection so it works with a parent v-model
    onInput: function (ev) {
      this.$emit('input', this.devotional)
    },
    fetchDevotionals: function () {
      // Any time we need to refresh our devotionals, we want the selector to
      // be unavailable for input
      this.isDisabled = true

      // If we don't have a set to work with, we don't know which devotionals to
      // pull, so we're done right away
      if (this.set === null) {
        return
      }

      var _this = this

      // Get information about our selected devotional set
      this.axios.get('/devotionals/sets/' + this.set)
        .then(function (res) {
          let set = res.data[0]

          // Get a list of request promises
          let reqs = set.devotionals.map(function (v) {
            return _this.axios.get('/devotionals/' + v)
          })

          // Send our requests to get devotional information
          _this.axios.all(reqs)
            .then(function (res) {
              // Get usable titles for the set's devotionals
              _this.devotionals = res.map(function (v) {
                let d = v.data[0]
                return { text: 'Devotional #' + d.index + ' (' + d.passage + ')', value: v.data[0].id }
              })

              // Re-enable the devotional selector
              _this.isDisabled = false
            })
            .catch(_this.$root.apiErrorHandler())
        })
        .catch(this.$root.apiErrorHandler())
    }
  }
}
</script>
